import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=b359fcda&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b359fcda')) {
      api.createRecord('b359fcda', component.options)
    } else {
      api.reload('b359fcda', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=b359fcda&", function () {
      api.rerender('b359fcda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KB4MFKRMApW9/JS/comp/openstreetmap.vue"
export default component.exports